import type * as React from 'react';
import { get } from '@Domain/Api';
import authenticatedUserFetched, {
	type AuthenticatedUserFetchedAction,
} from '@Application/Security/Authentications/Actions/authenticatedUserFetched';
import authenticatedUserFetchFailed, {
	type AuthenticatedUserFetchFailedAction,
} from '@Application/Security/Authentications/Actions/authenticatedUserFetchFailed';
import type { AuthenticatedUserPayload } from '@Application/Security/Authentications/Actions/userAuthenticated';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import { hasOpenedSession } from '@Infra/Token';
import parameters from '../../../parameters';

type Actions = AuthenticatedUserFetchedAction | AuthenticatedUserFetchFailedAction;

export default () => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			// An anonymous visitor never opened a session, so a 401 here just means "no session" and must
			// not trigger a refresh; a browser that did open one gets a refresh attempt when it expired.
			const payload = await get<AuthenticatedUserPayload>(`${parameters.api.host}/api/me`, {
				retryOnUnauthorized: hasOpenedSession(),
			});

			const action = authenticatedUserFetched(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = authenticatedUserFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
